<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import Banner from "../components/banner";
import profileditmezun from "./profileditmezun.vue";
import profileditfirma from "./profileditfirma.vue";
import sendinvite from "../mzneposta/sendinvite.vue";

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
    profileditmezun,
    profileditfirma,
    sendinvite,
  },
  data() {
    return {
      FormData: {},
      UserTur: null,
    };
  },
  methods: {
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: Page,
        Filter: "&Userid=" + this.TokenUserId,
      }).then((res) => {
        if (res.Data.length > 0) {
          this.UserTur = "Mezun";
          this.FormData = res.Data[0];
        } else {
          this.ActionsFilterGet({
            Service: this.$config.API_URL_2 + "mznfirma",
            Page: Page,
            Filter: "&Userid=" + this.TokenUserId,
          }).then((response) => {
            this.UserTur = "Firma";
            this.FormData = response.Data[0];
          });
        }
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <Banner />
 
      <div class="profile-user">
        <div class="row">
          <div class="col-md-12">
            <div class="text-sm-end">
              <a href="https://obsogrenci.tarsus.edu.tr/MezunDiplomaTalepleri" target="_blank" class="col-md-3">
                <button
                type="button"
                class="btn btn-success btn-rounded mb-2 me-2"
              >
                <i class="mdi mdi-mail me-1"></i
                >Diploma Talep
              </button>
              </a>
            </div>
            <div class="text-sm-end">
              <button
                type="button"
                class="btn btn-primary btn-rounded mb-2 me-2"
                v-b-modal.sendinvite
              >
                <i class="mdi mdi-mail me-1"></i
                >{{ $t("mznmezunlar.Page.sendinvite") }}
              </button>
            </div>
            <div class="profile-detail">
              <div class="row d-flex align-items-center justify-content-center">
                <profileditmezun
                  v-if="UserTur == 'Mezun'"
                  :FormData="FormData"
                />
                <profileditfirma
                  v-if="UserTur == 'Firma'"
                  :FormData="FormData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <sendinvite />
    </Layout>
  </Loader>
</template>
